export const angularServicesNames = {
    $translate: "$translate",
    $interval: "$interval",
    $uibModal: "$uibModal"
};
